import { Injectable } from '@angular/core';

import { CamCalendarData } from '../models/calendar/data';
import { CamSchedulerData } from '../models/scheduler/data';

@Injectable({
  providedIn: 'root',
})
export class CamPanningsDataService {
  public calendars: { [index: string]: CamCalendarData } = {};
  public schedulers: { [index: string]: CamSchedulerData } = {};

  public createCalendar(key: string) {
    if (!this.hasCalendar(key)) {
      this.calendars[key] = new CamCalendarData();
    }
  }

  public getCalendar(key: string, create: boolean = false) {
    if (!this.hasCalendar(key) && create) {
      this.createCalendar(key);
    }
    return this.calendars[key];
  }

  public hasCalendar(key: string) {
    return !!this.calendars[key];
  }

  public createScheduler(key: string) {
    if (!this.hasScheduler(key)) {
      this.schedulers[key] = new CamSchedulerData();
    }
  }

  public getScheduler(key: string, create: boolean = false) {
    if (!this.hasScheduler(key) && create) {
      this.createScheduler(key);
    }
    return this.schedulers[key];
  }

  public hasScheduler(key: string) {
    return !!this.schedulers[key];
  }
}
